import React from 'react';
import { PaymentMethodForm } from 'forms';
import { SettingsContent, SettingsContentLayout, SettingsPageHeader } from './components';

const PaymentMethodSettings = () => (
  <SettingsContent data-cy="payment-method-settings-container">
    <SettingsPageHeader />

    <SettingsContentLayout>
      <PaymentMethodForm />
    </SettingsContentLayout>
  </SettingsContent>
);

export default PaymentMethodSettings;
